import React from 'react';

const IconYellow = () => {
  return (
    <div>
      <svg
        width="43"
        height="43"
        viewBox="0 0 43 43"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="5"
          y="34"
          width="34"
          height="3"
          rx="1"
          fill="#B99D39"
          fill-opacity="0.31"
        />
        <rect
          x="8"
          y="31"
          width="11"
          height="6"
          rx="1"
          transform="rotate(-90 8 31)"
          fill="#B99D39"
          fill-opacity="0.31"
        />
        <rect
          x="19"
          y="31"
          width="17"
          height="6"
          rx="1"
          transform="rotate(-90 19 31)"
          fill="#B99D39"
          fill-opacity="0.31"
        />
        <rect
          x="31"
          y="31"
          width="25"
          height="6"
          rx="1"
          transform="rotate(-90 31 31)"
          fill="#B99D39"
          fill-opacity="0.31"
        />
      </svg>
    </div>
  );
};

export default IconYellow;
